import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import ssCompanyLogo from '../images/ss-company-logo.svg';
import {FaWallet, FaWhatsapp} from 'react-icons/fa';

const Header = ({
  title,
  showUser,
  balance,
  showMenu,
  sidebar,
  isMargen = false,
  showBackButton = true,
}) => {
  const [user, setUser] = useState(null);
  const [help, setHelp] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    const storedSetting = localStorage.getItem('setting');
    if (storedSetting) {
      setHelp(JSON.parse(storedSetting).help);
    }
  }, []);

  const _share = () => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      const shareData = {
        title: 'SS Company',
        text: `Refer your friends and receive 5% commission lifetime on every loss bidding (booking) of your friends! Use Referral Code - ${userData.referal_code} \n https://playparchi.com/app?referral=${userData.referal_code}`,
        url: 'https://playparchi.com/app',
      };
      if (navigator.share) {
        navigator.share(shareData).catch(error => {
          console.error('Error sharing', error);
        });
      } else {
        alert('Sharing not supported in this browser.');
      }
    }
  };

  const openWhatsApp = () => {
    if (help && help.text) {
      window.open(`https://wa.me/91${help.text}`, '_blank');
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div
      style={
        showUser
          ? styles.homeHeader
          : isMargen
          ? styles.headerMargen
          : styles.headerDefault
      }>
      <div style={styles.headerRow}>
        {showUser ? (
          <button
            onClick={() => sidebar?.(true)}
            style={styles.homeMenuButton}
            aria-label="Open menu">
            <svg
              width="23"
              height="23"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round">
              <path d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        ) : showBackButton ? (
          <button onClick={goBack} style={styles.backButton}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </button>
        ) : (
          <img src={ssCompanyLogo} alt="SS Company" style={styles.logo} />
        )}

        {showUser ? (
          <div style={styles.homeLogo} aria-label="SS Company">
            SS
          </div>
        ) : title ? (
          <div style={styles.pageTitle}>{title}</div>
        ) : null}

        <div style={styles.rightSection}>
          {showUser && (
            <button
              onClick={() => navigate('/walletoption')}
              style={styles.balancePill}>
              <FaWallet size={17} /> ₹ {Number(balance || 0).toFixed(2)}
            </button>
          )}
          {!showUser && (
            <button
              onClick={openWhatsApp}
              style={styles.iconButton}
              aria-label="Contact support">
              <FaWhatsapp size={20} />
            </button>
          )}
          {!showUser && (
            <button
              onClick={_share}
              style={styles.iconButton}
              aria-label="Share">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24">
                <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.03-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3z" />
              </svg>
            </button>
          )}

          {!showUser && (
            <button
              onClick={() => navigate('/more')}
              style={styles.iconButton}
              aria-label="More options">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>
          )}
        </div>
      </div>

      {isOpen && (
        <div style={styles.modalOverlay} onClick={() => setIsOpen(false)}>
          <div style={styles.modalContent}>
            <h2>Hello World!</h2>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  homeHeader: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    minHeight: '68px',
    padding: '8px 16px',
    borderBottom: '1px solid rgba(24, 181, 244, 0.16)',
    backgroundColor: '#062d36',
  },
  headerDefault: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#062d36',
    padding: '10px 20px',
    alignItems: 'center',
    borderRadius: '0 0 30px 30px',
  },
  headerMargen: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#062d36',
    padding: '10px 20px',
    alignItems: 'center',
    borderRadius: '8px',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  backButton: {
    background: 'none',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '5px',
  },
  homeMenuButton: {
    width: '46px',
    height: '46px',
    display: 'grid',
    placeItems: 'center',
    border: '1px solid rgba(28, 183, 241, 0.2)',
    borderRadius: '13px',
    color: '#20b8f3',
    background: '#0a4050',
    cursor: 'pointer',
  },
  homeLogo: {
    position: 'absolute',
    left: '50%',
    width: '40px',
    height: '40px',
    display: 'grid',
    placeItems: 'center',
    borderRadius: '6px',
    color: '#21baf2',
    background: '#052630',
    fontSize: '16px',
    fontWeight: 800,
    transform: 'translateX(-50%)',
  },
  pageTitle: {
    flex: 1,
    marginLeft: '16px',
    color: '#20b8f3',
    fontSize: '16px',
    fontWeight: 700,
  },
  logo: {
    width: '60px',
    height: '60px',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  iconButton: {
    width: '44px',
    height: '44px',
    display: 'grid',
    placeItems: 'center',
    background: '#0a4050',
    border: '1px solid rgba(28, 183, 241, 0.2)',
    borderRadius: '12px',
    color: '#20b8f3',
    cursor: 'pointer',
    fontSize: '16px',
  },
  balancePill: {
    minHeight: '44px',
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    padding: '0 13px',
    border: '1px solid rgba(28, 183, 241, 0.22)',
    borderRadius: '24px',
    color: '#20b8f3',
    background: '#0a4050',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
  },
};

export default Header;
